import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DeviceDetectionService {
    private getApplePaySession(): { canMakePayments: () => boolean } | undefined {
        return (window as Window & { ApplePaySession?: { canMakePayments: () => boolean } }).ApplePaySession;
    }

    isAppleDevice(): boolean {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod|macintosh|mac os x/i.test(userAgent);
    }

    isSafari(): boolean {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.includes('safari') && !userAgent.includes('chrome');
    }

    isApplePaySupported(): boolean {
        // Check if ApplePaySession exists and is supported
        const applePaySession = this.getApplePaySession();
        return !!applePaySession && applePaySession.canMakePayments();
    }

    isApplePayAvailable(): boolean {
        // Combine all checks for the most accurate detection
        return this.isAppleDevice() && this.isApplePaySupported();
    }

    getBrowserInfo(): { name: string; isSupported: boolean } {
        const userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
            return { name: 'Chrome', isSupported: true };
        } else if (userAgent.includes('firefox')) {
            return { name: 'Firefox', isSupported: true };
        } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
            return { name: 'Safari', isSupported: true };
        } else if (userAgent.includes('edg')) {
            return { name: 'Edge', isSupported: true };
        } else {
            return { name: 'Unknown', isSupported: false };
        }
    }
}
